import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IDriverLoadCommoditiesInitialState } from '../interfaces/IDriverLoadCommodities';
import { IDriverLoadCommodityResponseModel } from '../../../api/driverLoads/interfaces/IDriverLoadCommodity';
import driverLoadApi from '../../../api/driverLoads/driverLoadsApi';

export const fetchDriverLoadCommodities = createAsyncThunk(
    'fetchDriverLoadCommodities',
    async ({ shipmentId }: { shipmentId: number }, { rejectWithValue }) => {
        try {
            const response = await driverLoadApi.fetchDriverLoadCommodities(
                shipmentId,
            );
            return response;
        } catch {
            return rejectWithValue('Error');
        }
    },
);

const initialState: IDriverLoadCommoditiesInitialState = {
    loading: false,
    commodityList: [],
};

export const driverLoadCommoditiesSlice = createSlice({
    name: 'fetchDriverLoadCommodities',
    initialState,
    reducers: {
        setDriverLoadCommodityList: (
            state,
            action: PayloadAction<IDriverLoadCommodityResponseModel[]>,
        ) => {
            state.commodityList = action.payload;
        },
        clearDriverLoadCommodities: state => {
            state.commodityList = [];

            state.loading = false;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchDriverLoadCommodities.pending, state => {
            state.loading = true;
        });
        builder.addCase(
            fetchDriverLoadCommodities.fulfilled,
            (state, action) => {
                state.loading = false;
                state.commodityList = action.payload;
            },
        );
        builder.addCase(fetchDriverLoadCommodities.rejected, state => {
            state.loading = false;
        });
    },
});

export const { setDriverLoadCommodityList, clearDriverLoadCommodities } =
    driverLoadCommoditiesSlice.actions;

const DriverLoadCommoditiesReducer = driverLoadCommoditiesSlice.reducer;
export default DriverLoadCommoditiesReducer;
